<!-- schools slider -->
<div class="section section-schools-slider">

  <div class="container-section">

    <div class="row">
      <div class="col-12 column-left text-center">

        <div class="heading-wrapper">
          <h3 class="alternate-heading" *ngIf="global.config.locale.language.current == 'de'">
            Die Plattform von Meet the Youngsters wird von Studierenden der folgenden <span class="text-primary">Bildungseinrichtungen</span> genutzt.
          </h3>
          <h3 class="alternate-heading" *ngIf="global.config.locale.language.current != 'de'">
            {{'The platform of Meet the Youngsters is being used by students of the following' | translate}} <span class="text-primary">{{'educational institutions' | translate}}</span>
          </h3>
        </div>

      </div>
    </div>

    <div class="slider-schools">

      <!-- desktop view -->
      <span class="d-none d-sm-block">
        <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false" *ngIf="schoolSlider.slides_desktop">
          <ng-template *ngFor="let slide of schoolSlider.slides_desktop" ngbSlide>

            <div class="row">
              <div class="column-5 col" [ngClass]="{'d-none': !slideItem['imageUri']}" *ngFor="let slideItem of slide">
                <a class="company-link align-self-center" [routerLink]="'/schools/' + slideItem.id">
                  <div class="img-wrapper school-logo">
                    <img class="img-fluid image filter-grayscale" [src]="slideItem['imageUri']" />
                  </div>
                </a>
              </div>
            </div>

          </ng-template>
        </ngb-carousel>
      </span>

      <!-- mobile view -->
      <span class="d-block d-sm-none">
        <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false" *ngIf="schoolSlider.slides_mobile">
          <ng-template *ngFor="let slide of schoolSlider.slides_mobile" ngbSlide>

            <div class="row">
              <div class="col-6" [ngClass]="{'d-none': !slideItem['imageUri']}" *ngFor="let slideItem of slide">
                <a class="company-link align-self-center" [routerLink]="'/schools/' + slideItem.id">
                  <div class="img-wrapper school-logo">
                    <img class="img-fluid image filter-grayscale" [src]="slideItem['imageUri']" />
                  </div>
                </a>
              </div>
            </div>

          </ng-template>
        </ngb-carousel>
      </span>

    </div>

  </div>

</div>
